import { render, staticRenderFns } from "./LaudoTecnicoEletrica.vue?vue&type=template&id=1ae3413c&scoped=true"
import script from "./LaudoTecnicoEletrica.vue?vue&type=script&lang=js"
export * from "./LaudoTecnicoEletrica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3413c",
  null
  
)

export default component.exports